import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: Error | any;
  onRetry: () => void;
  className?: string;
  title?: string;
}

/**
 * Componente ErrorState - Muestra un estado de error con opción de reintentar
 */
export const ErrorState = ({ error, onRetry, className = 'h-64', title }: ErrorStateProps) => {
  const { t } = useTranslation('extraWorkOrdersModule');

  const errorMessage =
    error?.response?.data?.message || error?.message || t('toasts.error.unexpected', 'Error inesperado');

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="text-center">
        <div className="text-error text-4xl mb-4">⚠️</div>
        <h3 className="text-lg font-semibold text-title mb-2">{title || t('toasts.error.title', 'Error')}</h3>
        <p className="text-subtext mb-4">{errorMessage}</p>
        <Button onClick={onRetry} variant="outline" data-testid="retry-button">
          {t('actions.retry', 'Reintentar')}
        </Button>
      </div>
    </div>
  );
};
